import React from 'react'
import { withRouter } from 'react-router'
import { view } from 'react-easy-state'
import { isMobile } from 'react-device-detect'
import { Icon, Button, Row, Col } from 'antd'

import PaperView from 'components/pages/students/papers/show/PaperView'
import PaperRightSider from 'components/pages/students/papers/show/PaperRightSider'

import globalStore from 'store'

const paperViewGrid = {
  xs: {
    span: 24,
  },
  md: {
    span: 18,
  },
  lg: {
    span: 18,
  },
  xl: {
    span: 18,
  }
}

const paperSiderGrid = {
  xs: {
    span: 24,
  },
  md: {
    span: 6,
  },
  lg: {
    span: 6,
  },
  xl: {
    span: 6
  }
}
class PaperDetails extends React.Component {

  goBack = () => {
    const pageState = globalStore.ui.students.papers.show
    const { backUrl } = pageState
    this.props.history.push(backUrl)
  }

  togglePaperList = () => {
    const paperListSider = document.getElementById('paperListSider')
    paperListSider.classList.toggle('active')
  }

  goToSettingsPage = () => {
    this.props.history.push('/settings')
  }

  render() {

    const { paper, paperAttempt } = this.props

    const mobileHeader = <React.Fragment>
      <div className="left-menu">
        <Button type="link" onClick={this.goBack}><Icon type="arrow-left" /></Button>
        <Button type="link" onClick={this.togglePaperList}><Icon type="unordered-list" /></Button>
        <Button type="link" onClick={this.goToSettingsPage}><Icon type="setting" /></Button>
      </div>
      <div className="right-menu">
        {/* <Button type="link" onClick={this.goToNextPaper}><Icon type="arrow-right" /></Button> */}
      </div>
    </React.Fragment>

    return (
      <div className="lecture-view">
        <div className="header">
          {isMobile ? mobileHeader : <div>{paper.name}</div>}
        </div>
        <div className="lecture-content">
          <Row>
            <Col {...paperViewGrid}>
              <PaperView paper={paper}/>
            </Col>
            <Col {...paperSiderGrid}>
              <PaperRightSider paper={paper} paperAttempt={paperAttempt} coursePaymentDone={this.props.coursePaymentDone}/>
            </Col>
          </Row>
        </div>
      </div>
    )
  }
}

export default withRouter(view(PaperDetails))
